import { CardContent } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Content = styled(CardContent)`
  padding: 24px;
  margin: 0;
`;
